import PropTypes from 'prop-types';
import React from 'react';
import { FormControl, FormGroup, HelpBlock } from 'react-bootstrap';
import RequirableControlLabel from '../RequirableControlLabel/RequirableControlLabel';
import './SelectFormGroup.css';

const isError = (error, touched) => (error && touched ? 'error' : null);

// eslint-disable-next-line object-curly-newline
const SelectFormGroup = ({ label, meta, input, options, required, showBlank, ...props }) => (
  <FormGroup validationState={isError(meta.error, meta.touched)} >
    {label && <RequirableControlLabel required={required} >{label}</RequirableControlLabel> }
    <FormControl componentClass="select" placeholder="Job" {...input} {...props}>
      {showBlank && <option />}
      {
        options.map(({ id, name }) => <option value={id} key={id} >{name}</option>)
      }
    </FormControl>
    <FormControl.Feedback />
    {meta.touched && meta.error && <HelpBlock>{meta.error}</HelpBlock> }
  </FormGroup>
);

SelectFormGroup.defaultProps = {
  meta: {},
  input: {},
  options: [],
  required: false,
  showBlank: true,
};

SelectFormGroup.propTypes = {
  label: PropTypes.string.isRequired,
  meta: PropTypes.shape({}),
  required: PropTypes.bool,
  showBlank: PropTypes.bool,
  input: PropTypes.shape({}),
  options: PropTypes.arrayOf(PropTypes.shape({})),
};

export default SelectFormGroup;



// WEBPACK FOOTER //
// ./src/components/Forms/SelectFormGroup/SelectFormGroup.jsx